export default __webpack_public_path__ + "media/images/grass-bg-8a389a11df8374cb474c119de46f4932.svg";